<template>
  <form-section
    :title="$t('CampaignForm_Events_SelectEvent_Title')"
    :description="$t('CampaignForm_Events_SelectEvent_Desc')"
    :separator="true"
    :is-changed="model.diff && model.diff.includes('event')"
  >
    <el-row>
      <el-col :span="8">
        <form-item :label="$t('CampaignForm_Events_Event')">
          <el-autocomplete
            :placeholder="$t('CampaignForm_Select_Event')"
            clearable
            v-model="model.event_title"
            :fetch-suggestions="querySearchEvents"
            :select-when-unmatched="true"
            :popper-options="{
              modifiers: [
                hidePopover,
                'offset',
                'keepTogether',
                'arrow',
                'applyStyle'
              ]
            }"
            style="width: 100%"
            @select="handleSelectEvents"
            @blur="onBlur"
            @clear="clearEventsSelection"
          />
        </form-item>
      </el-col>
      <el-col :span="4" style="padding-top: 40px">
        <toggle
          v-model="model.event_filter"
          :text="$t('CampaignForm_Select_Event_Filter')"
        />
      </el-col>
    </el-row>

    <conditions-editor
      ref="conditions-editor"
      v-if="model.event_filter"
      v-model="model.event_conditions"
      data-model-name="Campaign"
      data-model-attribute="event_conditions"
      attribute-list-data-url="/push/event-filter/attribute-list-data"
      :preview="false"
      :no-data-alert="false"
      :single-level="true"
    />
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestApi from '@/core/services/RestApi'
import FormItem from '@/common/components/form/FormItem'
import ConditionsEditor from '@/common/components/ConditionsEditor'
import Toggle from '@/common/components/form/Toggle'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'EventSelector',

  components: {
    Toggle,
    ConditionsEditor,
    FormItem,
    FormSection
  },

  props: {
    model: {
      type: Object
    }
  },

  methods: {
    querySearchEvents(queryString, cb) {
      const params = {
        sort: 'title'
      }

      if (queryString !== null && queryString !== '') {
        params.title = queryString
      }

      RestApi(
        projectEndpoint({
          method: 'get',
          url: 'events',
          params: params
        })
      ).then(({ data }) => {
        const list = data.map(event => {
          return {
            value: event.title,
            type: event.type
          }
        })
        cb(list)
      })
    },

    onBlur() {
      this.handleSelectEvents({ type: 'custom' })
    },

    handleSelectEvents(selection) {
      this.model.event = selection.type ? selection.type : 'custom'
    },

    clearEventsSelection() {
      this.model.event = null
      this.model.event_title = null
    },

    hidePopover(data) {
      const refRect = data.offsets.reference
      const headerHeight =
        document.querySelector('header > .top-container').offsetHeight || 64

      data.styles.display = refRect.bottom - headerHeight < 0 ? 'none' : 'block'

      return data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/events/EventSelector.vue